import { getApiFunctions } from "store/bailiff/api";
import { API_BANKS } from "store/ref";
import { TYPES } from "./payment_withdraw.type";
import { getRefs } from "../ref";
import {
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getApp } from "firebase/app";

const app = getApp();
const auth = getAuth(app);

// ::::: FIREBASE
export const getPaymentWithdrawByDates =
  ({ from, to }) =>
  (dispatch) => {
    setPaymentWithdrawAllSuccess(dispatch, null);
    const cRef = getRefs().withdraw;
    const start = from?.toDate();
    const end = to?.toDate();
    const uid = auth?.currentUser?.uid;
    const c0 = where("owner", "==", uid);
    const c1 = where("source", "==", "supporter");
    const c2 = where("createAt", ">=", start);
    const c3 = where("createAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2, c3);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        setPaymentWithdrawAllSuccess(dispatch, data);
      }
    });
  };

// ::::: CLOUD
export const cloudGenerateWithdraw =
  ({ amount, source, accountNumber, code, accountName }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().payment.withdrawBailiffWallet;
    const options = { amount, source, accountNumber, code, accountName };
    functions(options)
      .then((res) => {
        console.log({ res });
        callback && callback({ status: 200 });
      })
      .catch((error) => {
        console.error("Error generating withdraw:", error);
        callback &&
          callback({ status: 500, data: error.message || "Please try again!" });
      });
  };

// ::::: fetch bank account
export const fetchBanksList = () => async (dispatch) => {
  setPaymentWithdrawBanksSuccess(dispatch, null);
  try {
    const response = await fetch(API_BANKS);
    const data = await response.json();
    console.log({ data });

    if (data?.code === "00") {
      const result = data?.data || [];
      console.log("snap banks:" + JSON.stringify(result.length));
      setPaymentWithdrawBanksSuccess(dispatch, result);
    }
  } catch (err) {
    console.log({ err });
  }
};

// :::: snap last.
const lastWithdrawSub = [];
export const snapLastWithdraw = () => (dispatch) => {
  setPaymentWithdrawLastSuccess(dispatch, null);
  const cRef = getRefs().withdraw;
  const uid = auth?.currentUser?.uid;
  const c0 = where("owner", "==", uid);
  const c1 = orderBy("createAt", "desc");
  const c2 = limit(1);
  const qRef = query(cRef, c0, c1, c2);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot?.docs?.map((doc) => doc?.data());
      const detail = data?.length > 0 ? data[0] : null;
      setPaymentWithdrawLastSuccess(dispatch, detail);
    }
  });

  lastWithdrawSub.push(unsub);
};

export const unSnapLastWithdraw = () => (dispatch) => {
  lastWithdrawSub.forEach((subscriber) => {
    subscriber();
  });
  lastWithdrawSub.length = 0;
};

// ::::: local
export const setPaymentWithdrawCode = (data) => (dispatch) => {
  setPaymentWithdrawCodeSuccess(dispatch, data);
};

export const setPaymentWithdrawSearch = (data) => (dispatch) => {
  setPaymentWithdrawSearchSuccess(dispatch, data);
};

// ::::: dispatch
const setPaymentWithdrawBanksSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PAYMENT_WITHDRAW_BANKS,
    payload: data,
  });
};

const setPaymentWithdrawCodeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PAYMENT_WITHDRAW_CODE,
    payload: data,
  });
};

const setPaymentWithdrawSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PAYMENT_WITHDRAW_SEARCH,
    payload: data,
  });
};

const setPaymentWithdrawAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PAYMENT_WITHDRAW_ALL,
    payload: data,
  });
};

const setPaymentWithdrawLastSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_PAYMENT_WITHDRAW_LAST,
    payload: data,
  });
};
